Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.BaselinePlannedRoute = function () {

    let _map;
    let _routeId;

    this.setMap = function (map) {
        _map = map;
    };

    this.setRouteId = function (routeId) {
        _routeId = routeId;
    };

    this.drawBaselinePlannedRoute = function () {

        const url = `Route/${_routeId}/EncodedBaselinePath`;

        $.get(url, function (encoded) {
            if (!Monet.Session.RouteDetail.screensList[_routeId]) return;
            const polyline = L.polyline(
              new Monet.PolylineEncoder().decode(encoded, false),
              {
                color: '#00AAFF',
                weight: 2
              }
            );
            polyline.kind = "BASELINE_PLANNED_ROUTE";
            _map.addLayer(polyline);
            polyline.bringToFront();
            Monet.Session.RouteDetail.screensList[_routeId].routeLayer = polyline;
            screen.canShowBaselinePlannedRoute = true;
        });

    };

    this.removeBaselinePlannedRoute = function () {

        const map = _map;

        for (let i in map._layers) {

            if (map._layers[i].kind === "BASELINE_PLANNED_ROUTE") {

                map.removeLayer(map._layers[i]);

            }

        }

    };
};
